import { Navigate } from 'react-router-dom';
import useStore from '../../store/index';
import { DisposeRouteProps } from './disposeRoute';
import type { ReactElement } from 'react';

// 路由前置守卫
const GuardRoute = ({ element }: DisposeRouteProps): ReactElement => {
  const { token } = useStore();
  // token鉴权
  if (!token) {
    return <Navigate to={{ pathname: '/login' }} replace />;
  }

  return <>{element}</>;
};

export default GuardRoute;
